import { isArray } from '@ember/array';
import ApplicationSerializer from '@square/dashboard-data/serializers/application';

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-param-reassign */
export default ApplicationSerializer.extend({
  primaryKey: 'iso_code',
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (isArray(payload)) {
      payload = {
        subareas: []
      };
    }
    if (!payload.subareas) {
      payload.subareas = [];
    }
    if (payload.subareas.length === 0) {
      payload.iso_code = '-1';
    } else {
      const newPayload = payload.subareas[0];
      newPayload.iso_code = newPayload.iso_code.replace('JP-', '');
      payload = newPayload;
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  }
});